import { NotificationsApi } from '@repo/api-gw-sdk';
import type {
  Configuration,
  NotificationPolicy,
  Condition,
} from '@repo/api-gw-sdk';
import type { ColumnSort, PaginationState } from '@tanstack/react-table';

import type { HttpClient } from './httpClient';

const baseUrl = '/notifications';

export const notifications = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const notificationsApi = new NotificationsApi(config);

  return {
    useList: (
      pagination: PaginationState,
      sorting: ColumnSort,
      columnFilters: Condition | undefined
    ) =>
      httpClient.execute(
        notificationsApi.listNotifications.bind(notificationsApi),
        baseUrl,
        '',
        currentProjectId,
        pagination.pageIndex,
        pagination.pageSize,
        `${sorting.id}:${sorting.desc ? 'desc' : 'asc'}`,
        { filter: columnFilters }
      ),
    policies: {
      useList: () =>
        httpClient.execute(
          notificationsApi.listNotificationPolicies.bind(notificationsApi),
          baseUrl,
          'policies',
          currentProjectId
        ),
      create: (notificationPolicy: NotificationPolicy) =>
        notificationsApi.createNotificationPolicy(
          currentProjectId,
          notificationPolicy
        ),
      update: (notificationPolicy: NotificationPolicy) =>
        notificationsApi.updateNotificationPolicy(
          currentProjectId,
          notificationPolicy.id,
          notificationPolicy
        ),
      delete: (id: string) =>
        notificationsApi.deleteNotificationPolicy(currentProjectId, id),
      test: (id: string) =>
        notificationsApi.testNotificationPolicy(currentProjectId, id),
    },
  };
};
